import { Column, ColumnType } from '@scale/compass-shared/types';
import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ChatBulkAuditResultsAdapterCardShared,
  type ChatBulkAuditResultsAdapterSchemaType,
  type ChatBulkAuditResultsAdapterContext,
  type ChatBulkAuditResultsFilter,
  CHAT_BULK_AUDIT_RESULTS_ADAPTER,
} from '@scale/genai-compass-shared/cards/chat_bulk_audit_results_adapter';
import { faComments } from '@fortawesome/pro-solid-svg-icons';
import ChatBulkAuditResultsCardComponent from 'react-scale/corp/views/DataCompassCardsV2/adapter/ChatBulkAuditResultsCard/ChatBulkAuditResultsCardComponent';

/** Input columns for Chat Bulk Audit Results Adapter filtering. */
export const CHAT_BULK_AUDIT_RESULTS_INPUT_COLUMNS: Record<
  string,
  Column & { id: keyof ChatBulkAuditResultsFilter }
> = {
  auditBatchId: {
    id: 'auditBatchId',
    header: 'Audit Batch ID',
    type: ColumnType.SINGLE_OBJECT_ID,
  },
};

const defaultContext: ChatBulkAuditResultsAdapterContext = {
  cardType: CHAT_BULK_AUDIT_RESULTS_ADAPTER,

  filter: {
    operator: 'and',
    filtersOrFilterGroups: [
      {
        column: CHAT_BULK_AUDIT_RESULTS_INPUT_COLUMNS.auditBatchId,
        condition: 'is',
        term: '',
      },
    ],
  },
  auditBatchId: '',
};

export const ChatBulkAuditResultsCardInfo: CompassCardUI<ChatBulkAuditResultsAdapterSchemaType> = {
  ...ChatBulkAuditResultsAdapterCardShared,
  title: 'Chat Bulk Audit Results',
  icon: 'comments',
  toolTip: 'Filter chat bulk audit results',
  defaultContext,
  ownerTeam: 'Quality',
  button: {
    title: 'CBA',
    icon: faComments,
  },
  legacyComponent: ChatBulkAuditResultsCardComponent,
};
